import { render, staticRenderFns } from "./deployCoupon.vue?vue&type=template&id=c0e2cbb0&scoped=true&"
import script from "./deployCoupon.vue?vue&type=script&lang=js&"
export * from "./deployCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e2cbb0",
  null
  
)

export default component.exports